import {Button, Col, DatePicker, Form, Input, Row} from 'antd';
import {isValidPhoneNumber} from 'libphonenumber-js';
import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import AppConfig from '../../../../configs/AppConfig';

const EditProfile = ({userDetails, refreshUser, setIsEditing, isEditing}) => {
  const [form] = Form.useForm();

  const token = useSelector(state => state.auth.tokenData);

  const {id} = useParams();

  useEffect(() => {
    if (userDetails) {
      form.setFieldsValue({
        ...userDetails,
        // dob: userDetails.dob ? dayjs(userDetails.dob) : null,
        // anniversary: userDetails.anniversary ? dayjs(userDetails.anniversary) : null,
      });
    }
  }, [userDetails, form]);

  const handleUpdate = async values => {
    try {
      const response = await fetch(`${AppConfig.API_BASE_URL}/api/user/${id}/update/allfields`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...values,
          dob: values.dob?.format('YYYY-MM-DD'),
          anniversary: values.anniversary?.format('YYYY-MM-DD'),
        }),
      });

      const result = await response.json();
      console.log('Status:', response.status, result);

      if (!response.ok) {
        throw new Error(result?.message || 'Failed to update profile');
      }

      await refreshUser(); 
      setIsEditing(false); 

    } catch (error) {
      console.error('Error updating profile:', error.message);
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleUpdate}
      layout={'vertical'}
      autoComplete={'off'}
      style={{maxWidth: 800, margin: '0 auto'}}
    >
      <Row gutter={16}>

        <Col span={12}>
          <Form.Item label={'First Name'} name={'firstName'}>
            <Input />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={'Last Name'} name={'lastName'}>
            <Input />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={'Email'} name={'email'} rules={[{type: 'email', message: 'Enter a valid email'}]}>
            <Input disabled />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label={'Phone'}
            name={'mobile'}
            rules={[
              {
                validator: (_, value) =>
                  !value || isValidPhoneNumber(value, 'IN')
                    ? Promise.resolve()
                    : Promise.reject('Enter a valid 10-digit Indian number'),
              },
            ]}
          >
            <Input inputMode={'tel'} maxLength={13} placeholder={'+91xxxxxxxxxx'} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={'DOB'} name={'dob'}>
            <DatePicker style={{width: '100%'}} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={'Anniversary'} name={'anniversary'}>
            <DatePicker style={{width: '100%'}} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={'Address'} name={'address'}>
            <Input />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item>
            <Button type={'primary'} htmlType={'submit'}>
              Update
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

EditProfile.propTypes = {
  userDetails: PropTypes.object,
  refreshUser: PropTypes.func.isRequired,
  setIsEditing: PropTypes.func.isRequired, 
  isEditing: PropTypes.bool.isRequired,
};

export default EditProfile;
